import { render } from "./QuestionBoolean.vue?vue&type=template&id=f4ea90b8"
import script from "./QuestionBoolean.vue?vue&type=script&lang=js"
export * from "./QuestionBoolean.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__